import React from 'react';

export const VenetianCord = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 88.4 88.4"
      {...props}
    >
      <circle
        cx={44.2}
        cy={44.2}
        r={43.5}
        fill="#fff"
        stroke="#233762"
        strokeWidth={1.449}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
      />
      <g fill="#010101">
        <path d="M32.3 78.3c.1 0 .1.1.2.2l.3.8c-.5.2-.9.4-1.5.4-.5 0-1.1-.1-1.7-.4-.5-.2-1-.5-1.3-.9-.4-.4-.6-.8-.8-1.3-.2-.5-.2-1-.2-1.5s.2-1.1.4-1.6.5-1 .9-1.4c.4-.4.8-.7 1.3-.8.5-.2 1-.3 1.5-.3s1.1.1 1.6.4c.5.2 1 .5 1.3.9.3.3.6.7.7 1.1l-.7.4s-.1 0-.1.1H34c-.1 0-.1-.1-.2-.2s-.1-.2-.2-.3-.2-.3-.4-.4c-.2-.1-.4-.3-.7-.4-.3-.1-.7-.2-1-.2-.3 0-.7.1-1 .2s-.6.3-.8.6c-.3.3-.5.6-.6 1-.2.4-.3.8-.3 1.2s0 .7.1 1c.1.3.3.6.5.8.2.2.5.4.8.6.2.1.4.1.5.2.2 0 .3.1.5.1h.4c.1 0 .3-.1.4-.1h.1c.1-.3.2-.2.2-.2zM43.8 78.4c-.1.6-.2 1.1-.5 1.6s-.6.9-1 1.2-.9.5-1.4.7-1.1.2-1.7.1c-.6-.1-1.1-.3-1.6-.5-.5-.3-.8-.6-1.2-1-.3-.4-.5-.9-.6-1.4-.1-.5-.2-1.1-.1-1.6.1-.6.2-1.1.5-1.6s.6-.9 1-1.2c.4-.3.9-.5 1.4-.7s1.1-.2 1.7-.1c.6.1 1.1.3 1.6.5.5.3.8.6 1.1 1 .3.4.5.9.6 1.4s.2 1 .2 1.6zm-1.5-.2c.1-.4.1-.8 0-1.2-.1-.4-.2-.7-.4-.9-.2-.3-.4-.5-.7-.7-.3-.2-.6-.3-1-.3-.4-.1-.7 0-1.1.1-.3.1-.6.2-.9.4-.2.2-.5.5-.6.8-.2.3-.3.7-.3 1.1-.1.4-.1.8 0 1.2.1.4.2.7.4.9.2.3.4.5.7.7s.6.3 1 .3c.4.1.7 0 1.1-.1s.6-.2.9-.4.5-.5.6-.8c.1-.3.2-.7.3-1.1zM47.9 78.9l.4 3.1-1.5.2-1.1-7.9 2.4-.3c.5-.1 1-.1 1.4 0s.7.2 1 .3c.3.2.5.4.6.6.2.3.3.6.3.9v.8c0 .3-.1.5-.3.7-.1.2-.3.4-.5.6-.2.2-.4.3-.7.4.2.1.4.2.5.4l2.4 2.6-1.3.2h-.3c-.1 0-.2-.1-.3-.2l-2-2.3c-.1-.1-.2-.1-.2-.2h-.3l-.5.1zm-.2-1.1l.9-.1c.3 0 .5-.1.7-.2.2-.1.4-.2.5-.4s.2-.3.2-.5V76c-.1-.4-.2-.7-.5-.9-.3-.2-.7-.2-1.3-.2l-.9.1.4 2.8zM61.1 74c.2.5.3 1.1.4 1.6 0 .5-.1 1-.3 1.5-.2.5-.5.9-.9 1.2s-.8.7-1.4.9l-2.8 1.2-3.1-7.3 2.8-1.2c.6-.2 1.1-.4 1.6-.4s1 .1 1.5.3c.5.2.9.5 1.2.8.5.4.7.9 1 1.4zm-1.4.6c-.2-.4-.4-.7-.6-1-.2-.3-.5-.5-.8-.6-.3-.1-.6-.2-.9-.2-.3 0-.7.1-1 .2l-1.4.6 2.2 5.2 1.4-.6c.4-.2.7-.3.9-.6.2-.2.4-.5.5-.8s.1-.6.1-1c-.1-.4-.2-.8-.4-1.2z" />
      </g>
      <defs>
        <circle id="prefix__a" cx={44.2} cy={44.2} r={36.5} />
      </defs>
      <clipPath id="prefix__b">
        <use xlinkHref="#prefix__a" overflow="visible" />
      </clipPath>
      <g
        clipPath="url(#prefix__b)"
        fill="#233762"
        stroke="#fff"
        strokeMiterlimit={10}
      >
        <path
          strokeWidth={0.841}
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M37.4-8.9h3V34h-3z"
        />
        <path
          strokeWidth={1.027}
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M48-8.9h3v64h-3z"
        />
        <path
          d="M43.8 42h-9.7V25.4c0-2.3 1.8-4.1 4.1-4.1h1.5c2.3 0 4.1 1.8 4.1 4.1V42zM54.3 65.7h-9.7V49.1c0-2.3 1.8-4.1 4.1-4.1h1.5c2.3 0 4.1 1.8 4.1 4.1v16.6z"
          strokeWidth={0.769}
        />
      </g>
    </svg>
  );
};
